import React from 'react';
import { makeStyles } from '@material-ui/core/styles';

interface HiddenProps {
  children: any;
  isHidden: boolean;
  margin?: string;
}

const useStyles = makeStyles({
  hiddenContainer: {
    borderRadius: '20px',
    display: 'block'
  }
});

const Hidden = ({ children, isHidden, margin }: HiddenProps) => {
  const classes = useStyles();
  return (
    <span
      className={classes.hiddenContainer}
      style={{
        backgroundColor: isHidden ? '#E2E9F0' : 'transparent',
        margin: margin,
        height: isHidden ? '1rem' : 'unset'
      }}
    >
      <span style={{ visibility: isHidden ? 'hidden' : 'visible' }}>
        {children}
      </span>
    </span>
  );
};

export default Hidden;
